import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useAddChallenge = () => {
  return useMutation((newTest) => {
    return axiosPost("/api/cw/createChallenge", newTest);
  });
};

export default useAddChallenge;
